import React from "react";
import "./Requirements.css";
import requirementsImage from "../Assets/image49.jpg";

const Requirements = () => {
  return (
    <div className="requirements-box">
      <img src={requirementsImage} alt="Rules" />
      <div className="requirements-container">
        <h2>All You Need to Know about Our Club</h2>
        <div className="text-container">
          <p className="column">
            1. Roller Hockey Practice Groups: Our dynamic practice groups are
            tailored for children aged 5 to 18. These groups are more than just
            teammates; they're a family. Older members take on the role of
            guides and mentors, creating a supportive environment for everyone.
            <br />
            <br />
            2. Requirements to Join the Club: To kickstart your roller hockey
            journey with us, fill out a registration form and attach a copy of
            your ID, EPS affiliation certificate (health insurance), and student
            insurance (if applicable). Dive into our club's world by reading and
            signing regulatory forms covering membership, consents, sports
            evaluations, and data privacy.
            <br />
            <br />
            3. Equipment for Roller Hockey Practice: Gear up with four-wheel
            skates, a trusty stick, and protective elements like knee pads, shin
            guards, and gloves. Our club provides three training uniforms from
            Monday to Friday, and on Saturdays, we rock our iconic club bibs. If
            you're just starting out, worry not – the club lends skates and
            sticks for your initial steps into the exciting world of roller
            hockey.
            <br />
            <br />
            4. Roller Hockey Practice Time: Get ready for action! Roller hockey
            practices run for 6.5 hours per week – Mondays, Wednesdays, and
            Fridays from 7:00 to 8:30 pm, and Saturdays from 3:30 to 5:30 pm.
            Join us at Liga Vallecaucana de Patinaje - Autopista sur con 32. Our
            Hockey Training School, located at Colseguros Park, offers an
            additional hour and a half of training on Saturdays from 3:30 to
            5:30 pm.
            <br />
            <br />
            5. Roller Hockey Practice: Experience the thrill of roller hockey
            through our playful teaching methodology. We use the game as a tool
            to impart skills like skate handling, stick maneuvers, and the rules
            of roller hockey. Healthy competition and an atmosphere of respect
            are fostered through games among club members. It's not just
            practice; it's a chance for the kids to learn from seasoned roller
            hockey athletes, building camaraderie and sportsmanship.
            <br />
            <br />
            6. Health Insurance: Safety first! Athletes must be affiliated with
            an EPS for all sports practices, including roller hockey. The club
            takes an extra step by securing accident insurance for athletes
            during training sessions.
            <br />
            <br />
            7. Monthly Payments: Being part of the roller hockey excitement
            comes with a monthly fee of $60,000. We value prompt payments, and
            to show our appreciation, we've set up an incentive system: • Pay
            within the first 10 days: COP $50,000. • Pay between the 11th and
            20th: COP $55,000. • Payments after the 20th: Full fee of COP
            $60,000. For our fantastic Hockey School, held once a week, the
            monthly fee is an affordable COP $30,000. Roll into action with our
            roller hockey family – where passion meets playfulness!{" "}
            <span role="img" aria-label="stick">
              🏒
            </span>
            <span role="img" aria-label="goal">
              🥅
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Requirements;
